function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n  \n  @media (max-width: 768px) {\n    padding: 1rem 0.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: var(--paper, #ffffff);\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--theme-border);\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  color: var(--theme-text);\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.75rem 1rem;\n  flex-shrink: 0;\n  gap: 0.5rem;\n  \n  &:hover {\n    background-color: var(--theme-paper-hover);\n    border-color: var(--theme-border-light);\n  }\n  \n  &:active {\n    transform: scale(0.98);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0;\n  border-bottom: 1px solid var(--border, #e5e7eb);\n  \n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--paper-light, #f9fafb);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary, #6b7280);\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--text-secondary, #6b7280);\n  margin-bottom: 0.25rem;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500;\n  color: var(--text, #1f2937);\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  color: var(--theme-text-secondary);\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.5rem;\n  flex-shrink: 0;\n  \n  &:hover {\n    background-color: var(--theme-paper-hover);\n    color: var(--theme-text);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  background: var(--paper, #ffffff);\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text, #1f2937);\n  margin: 0 0 1.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-radius: 8px;\n  cursor: ",
        ";\n  transition: all 0.2s ease;\n  opacity: ",
        ";\n  \n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--paper-light, #f9fafb);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary, #3b82f6);\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500;\n  color: var(--text, #1f2937);\n  margin-bottom: 0.25rem;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--text-secondary, #6b7280);\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  background: var(--primary, #3b82f6);\n  color: white;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  background: var(--paper, #ffffff);\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #dc2626;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  color: #dc2626;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.75rem 1rem;\n  width: 100%;\n  gap: 0.5rem;\n  \n  &:hover {\n    background: #dc2626;\n    color: white;\n  }\n  \n  &:active {\n    transform: scale(0.98);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { Mail } from 'lucide-react';
import { Phone } from 'lucide-react';
import { Edit3 } from 'lucide-react';
import { ChevronRight } from 'lucide-react';
import { LogOut } from 'lucide-react';
import { Settings as SettingsIcon } from 'lucide-react';
import { AuthorDisplay } from '@edusense/shared-ui';
var TemplateContainer = styled.div(_templateObject());
var UserSection = styled.div(_templateObject1());
var UserHeader = styled.div(_templateObject2());
var EditProfileButton = styled.button(_templateObject3());
var AccountInfo = styled.div(_templateObject4());
var AccountInfoItem = styled.div(_templateObject5());
var InfoLeft = styled.div(_templateObject6());
var InfoIcon = styled.div(_templateObject7());
var InfoContent = styled.div(_templateObject8());
var InfoLabel = styled.div(_templateObject9());
var InfoValue = styled.div(_templateObject10());
var EditButton = styled.button(_templateObject11());
var SettingsSection = styled.div(_templateObject12());
var SectionTitle = styled.h3(_templateObject13());
var SettingsGrid = styled.div(_templateObject14());
var SettingItemContainer = styled.div(_templateObject15(), function(props) {
    return props.disabled ? 'default' : 'pointer';
}, function(props) {
    return props.disabled ? 0.6 : 1;
}, function(props) {
    return props.disabled ? 'transparent' : 'var(--paper-hover, #f3f4f6)';
});
var SettingItemLeft = styled.div(_templateObject16());
var SettingItemIcon = styled.div(_templateObject17());
var SettingItemContent = styled.div(_templateObject18());
var SettingItemTitle = styled.div(_templateObject19());
var SettingItemDescription = styled.div(_templateObject20());
var SettingItemRight = styled.div(_templateObject21());
var SettingItemBadge = styled.span(_templateObject22());
var LogoutSection = styled.div(_templateObject23());
var LogoutButton = styled.button(_templateObject24());
var SettingsTemplate = function(param) {
    var user = param.user, sections = param.sections, onItemClick = param.onItemClick, onToggleChange = param.onToggleChange, onEditProfile = param.onEditProfile, onEditEmail = param.onEditEmail, onEditPhone = param.onEditPhone, onLogout = param.onLogout, headerCustomComponent = param.headerCustomComponent, footerCustomComponent = param.footerCustomComponent;
    var displayName = user.name || user.username || '사용자';
    var handleItemClick = function(item) {
        if (item.disabled) return;
        if (item.toggle) {
            onToggleChange(item.id, !item.isToggleActive);
        } else if (item.action) {
            item.action();
        } else {
            onItemClick(item);
        }
    };
    return /*#__PURE__*/ React.createElement(TemplateContainer, null, headerCustomComponent, /*#__PURE__*/ React.createElement(UserSection, null, /*#__PURE__*/ React.createElement(UserHeader, null, /*#__PURE__*/ React.createElement(AuthorDisplay, {
        author: {
            id: user.id,
            name: displayName,
            username: user.username,
            profileImage: user.profileImage
        },
        size: "xl",
        showTimestamp: false,
        layout: "stacked"
    }), /*#__PURE__*/ React.createElement(EditProfileButton, {
        onClick: onEditProfile
    }, /*#__PURE__*/ React.createElement(Edit3, {
        size: 16
    }), "편집")), /*#__PURE__*/ React.createElement(AccountInfo, null, /*#__PURE__*/ React.createElement(AccountInfoItem, null, /*#__PURE__*/ React.createElement(InfoLeft, null, /*#__PURE__*/ React.createElement(InfoIcon, null, /*#__PURE__*/ React.createElement(Mail, {
        size: 20
    })), /*#__PURE__*/ React.createElement(InfoContent, null, /*#__PURE__*/ React.createElement(InfoLabel, null, "이메일"), /*#__PURE__*/ React.createElement(InfoValue, null, user.email || '설정되지 않음'))), /*#__PURE__*/ React.createElement(EditButton, {
        onClick: onEditEmail
    }, /*#__PURE__*/ React.createElement(Edit3, {
        size: 16
    }))), user.phone && /*#__PURE__*/ React.createElement(AccountInfoItem, null, /*#__PURE__*/ React.createElement(InfoLeft, null, /*#__PURE__*/ React.createElement(InfoIcon, null, /*#__PURE__*/ React.createElement(Phone, {
        size: 20
    })), /*#__PURE__*/ React.createElement(InfoContent, null, /*#__PURE__*/ React.createElement(InfoLabel, null, "전화번호"), /*#__PURE__*/ React.createElement(InfoValue, null, user.phone))), /*#__PURE__*/ React.createElement(EditButton, {
        onClick: onEditPhone
    }, /*#__PURE__*/ React.createElement(Edit3, {
        size: 16
    }))))), sections.map(function(section) {
        return /*#__PURE__*/ React.createElement(SettingsSection, {
            key: section.id
        }, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(SettingsIcon, {
            size: 20
        }), section.title), /*#__PURE__*/ React.createElement(SettingsGrid, null, section.items.map(function(item) {
            return /*#__PURE__*/ React.createElement(SettingItemContainer, {
                key: item.id,
                disabled: item.disabled,
                onClick: function() {
                    return handleItemClick(item);
                }
            }, /*#__PURE__*/ React.createElement(SettingItemLeft, null, /*#__PURE__*/ React.createElement(SettingItemIcon, null, /*#__PURE__*/ React.createElement(item.icon, {
                size: 20
            })), /*#__PURE__*/ React.createElement(SettingItemContent, null, /*#__PURE__*/ React.createElement(SettingItemTitle, null, item.title), /*#__PURE__*/ React.createElement(SettingItemDescription, null, item.description))), /*#__PURE__*/ React.createElement(SettingItemRight, null, item.badge && /*#__PURE__*/ React.createElement(SettingItemBadge, null, item.badge), item.customComponent || (item.toggle ? /*#__PURE__*/ React.createElement("input", {
                type: "checkbox",
                checked: item.isToggleActive || false,
                onChange: function(e) {
                    return onToggleChange(item.id, e.target.checked);
                },
                disabled: item.disabled
            }) : /*#__PURE__*/ React.createElement(ChevronRight, {
                size: 20,
                color: "var(--text-muted, #9ca3af)"
            }))));
        })));
    }), /*#__PURE__*/ React.createElement(LogoutSection, null, /*#__PURE__*/ React.createElement(LogoutButton, {
        onClick: onLogout
    }, /*#__PURE__*/ React.createElement(LogOut, {
        size: 16
    }), "로그아웃")), footerCustomComponent);
};
export default SettingsTemplate;
